import IValidateCustomerDocumentRepository, {
  TValidateCustomerDocumentResponse,
} from 'modules/authentication/domain/repositories/IValidateCustomerDocumentRepository';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisValidateCustomerDocumentRepository
  implements IValidateCustomerDocumentRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public validate: IValidateCustomerDocumentRepository['validate'] = document =>
    this.httpProvider.post<TValidateCustomerDocumentResponse>(
      'clientes/buscarCanaisClientePorCpf',
      {
        numeroCpf: document,
      },
    );
}
